// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardClients_scroll{
    --gradientColor: #fff;
    --gradientEmptyColor: #fff0;
    height: 100%;
    overflow: hidden;
}

.DashboardClients_scroll .GoodScroll_visualScroll {
    display: none !important;
}

.DashboardClients_scroll .GoodScroll_scrollThumb {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 3px;
    width: 6px;
}

.dashboard_tabContent_clients {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.dashboard_tabContents {
    height: calc(100% - 50px);
    overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/DashboardClients.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB","sourcesContent":[".DashboardClients_scroll{\n    --gradientColor: #fff;\n    --gradientEmptyColor: #fff0;\n    height: 100%;\n    overflow: hidden;\n}\n\n.DashboardClients_scroll .GoodScroll_visualScroll {\n    display: none !important;\n}\n\n.DashboardClients_scroll .GoodScroll_scrollThumb {\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 3px;\n    width: 6px;\n}\n\n.dashboard_tabContent_clients {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.dashboard_tabContents {\n    height: calc(100% - 50px);\n    overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
